import logUtil from 'utils/log'
import isValidZipCodeShippingUtil from 'modules/shipping/utils/is-valid-zip-code'

const isEligibleToTemporaryUnlockedSamplesSelectUtil = (props) => {
  logUtil('isEligibleToTemporaryUnlockedSamplesSelectUtil').debug('props=', props)
  const { isNewCustomer, isDeliveryAvailable, zipCode } = props
  return (
    isNewCustomer &&
    // TODO omit if it causes issues
    // We assume delivery is available since nationwide is enabled
    (isValidZipCodeShippingUtil(zipCode) && (isDeliveryAvailable == null || isDeliveryAvailable === true))
    // isDeliveryAvailable === true
  )
}

export default isEligibleToTemporaryUnlockedSamplesSelectUtil
